module.exports = __webpack_public_path__ + "media/images/privacy-73eb2c42346212f4eb209c2a53bd2543.jpg";